exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._3pQtQ9wNKFkyj4LkvlT28P{padding:0 12px}html[dir] .lqyHCMN0Ds0F3dxL1ZTJM{border-radius:4px!important}", ""]);
// Exports
exports.locals = {
	"newMessageButtonPadding": "_3pQtQ9wNKFkyj4LkvlT28P",
	"newMessageButtonWithIcon": "lqyHCMN0Ds0F3dxL1ZTJM"
};